import { Select } from '@/components/ui/select'

type Props = {
  onFilterChange?: (value: string) => void
  currentPage: number
  totalItems: number
  itemsPerPage: number
}

export const ReviewsHeaderList = ({
  onFilterChange,
  currentPage,
  totalItems,
  itemsPerPage,
}: Props) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalItems)

  const sortOptions = [
    {
      value: 'star_order_by:desc',
      label: <span>Đánh giá: Cao tới thấp</span>,
    },
    {
      value: 'star_order_by:asc',
      label: <span>Đánh giá: Thấp tới cao</span>,
    },
  ]

  return (
    <div className='mb-2 flex items-center justify-between'>
      <p className='font-sans text-sm leading-4.5 text-neutral-500'>
        Hiển thị đánh giá{' '}
        <b>
          {startItem}-{endItem}
        </b>
      </p>
      <Select
        placeholder='Sắp xếp'
        className={{
          trigger:
            'w-fit data-[placeholder]:font-normal data-[placeholder]:text-neutral-500',
        }}
        options={sortOptions}
        onValueChange={(value) => onFilterChange?.(value)}
        aria-label='Sắp xếp'
      />
    </div>
  )
}
